import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import Media from 'react-media';
import TinySliderCarousel from '../../../components/globals/TinySliderCarousel';
import { SliderToolsImages } from '../../../assets/images/imageRepository';
import colors from '../../../styled/colors';
import Feature from '../components/Feature';
import mediaQueries from '../../../utils/mediaQueries';
import { ButtonPrimary } from '../../landing/components/Buttons';
import PromoCodeContext from '../../../contexts/PromoCodeContext';
import sanitizePlans from '../../CreateAccount/sanitizePlans';
import routes from '../../../utils/constants/routes';
import { breakpointValues } from '../../../styled/GlobalTheme';

const Section = styled.section``;
const SlidersContainer = styled.div``;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 38px;
  padding-bottom: 58px;
  @media ${mediaQueries.mdUp} {
    padding-top: 46px;
    padding-bottom: 88px;
  }
`;
const CustomButtonPrimary = styled(ButtonPrimary)`
  && {
    @media ${mediaQueries.mdUp} {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
`;

const Features = () => {
  const intl = useIntl();
  const history = useHistory();
  const { PromoCode } = useContext(PromoCodeContext);
  const [trialDays, setTrialDays] = useState(0);

  useEffect(() => {
    const [monthlyPlan] = sanitizePlans(PromoCode);
    setTrialDays(monthlyPlan.trialDuration);
  }, [PromoCode]);

  const features = [
    {
      id: 'instagram',
      title: (
        <FormattedMessage
          id={
            window.innerWidth < breakpointValues.xlPlus
              ? 'tools.features.instagram.title.mobile'
              : 'tools.features.instagram.title'
          }
          defaultMessage="Instagram, {lineBreak}supercharged!"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      description: (
        <FormattedMessage
          id={
            window.innerWidth < breakpointValues.xlPlus
              ? 'tools.features.instagram.description.mobile'
              : 'tools.features.instagram.description'
          }
          defaultMessage="Schedule with ease,  or publish immediately to Stories. No delay. Images and videos are automatically optimized for speedy delivery."
        />
      ),
      description2: '',
      image:
        intl.locale === 'es'
          ? SliderToolsImages.instagram.desktopEs
          : SliderToolsImages.instagram.desktop,
      size: {
        mobile: '306px',
        desktop: '388px',
      },
      backgroundColor: colors.lightBlue,
      columnGap: '133px',
      marginBottomTitle: intl.locale === 'es' ? '32px' : '45px',
    },
    {
      id: 'time',
      title: (
        <FormattedMessage
          id="tools.features.time.title"
          defaultMessage="Time-saving tricks:"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      description: (
        <FormattedMessage
          id="tools.features.time.description"
          defaultMessage="Wheee!  Post  stories, images, and videos to all your social profiles WITHIN SECONDS, simultaneously."
        />
      ),
      description2: '',
      image:
        intl.locale === 'es'
          ? SliderToolsImages.time.desktopEs
          : SliderToolsImages.time.desktop,
      size: {
        mobile: '306px',
        desktop: '420px',
      },
      backgroundColor: colors.orange03,
      columnGap: '57px',
      marginBottomTitle: intl.locale === 'es' ? '36px' : '54px',
    },
    {
      id: 'bestTime',
      title: (
        <FormattedMessage
          id="tools.features.bestTime.title"
          defaultMessage="Better, Better, Best"
        />
      ),
      description: (
        <FormattedMessage
          id="tools.features.bestTime.description"
          defaultMessage="With Piper’s tips and tricks you’ll grow reach and engagement."
        />
      ),
      description2: (
        <FormattedMessage
          id="tools.features.bestTime.description2"
          defaultMessage="Feedback from Piper and insights from experts help you stay at the top of your game. "
        />
      ),
      image:
        intl.locale === 'es'
          ? SliderToolsImages.bestTime.desktopEs
          : SliderToolsImages.bestTime.desktop,
      size: {
        mobile: '306px',
        desktop: '461px',
      },
      backgroundColor: colors.green05,
      columnGap: '56px',
      marginBottomTitle: '30px',
    },
    {
      id: 'boost',
      title: (
        <FormattedMessage
          id="tools.features.boost.title"
          defaultMessage="Boost for success!"
        />
      ),
      description: (
        <FormattedMessage
          id="tools.features.boost.description"
          defaultMessage="Piper helps you manage your ad spending to reach your biggest audience:"
        />
      ),
      description2: (
        <FormattedMessage
          id="tools.features.boost.description2"
          defaultMessage="“You have $45 left and could reach a target of 10,000 users with a boost post tonight.“"
        />
      ),
      image:
        intl.locale === 'es'
          ? SliderToolsImages.boost.desktopEs
          : SliderToolsImages.boost.desktop,
      size: {
        mobile: '306px',
        desktop: '503px',
      },
      backgroundColor: colors.lightBlue,
      columnGap: '30px',
      marginBottomTitle: '26px',
    },
  ];
  return (
    <Media queries={mediaQueries}>
      {(matches) => (
        <Section>
          <SlidersContainer>
            <TinySliderCarousel
              bottomPagination={matches.mdDownLess ? '40px' : '48px'}
              settings={{
                autoplayTimeout: 7000,
              }}
            >
              {features.map((feature) => (
                <Feature feature={feature} key={feature.id} />
              ))}
            </TinySliderCarousel>
          </SlidersContainer>
          <ButtonContainer>
            <CustomButtonPrimary
              largeText={matches.mdDownLess}
              onClick={() => history.push(routes.CREATE_ACCOUNT)}
            >
              {trialDays > 0 ? (
                <FormattedMessage
                  id={
                    matches.xlPlusDownLess
                      ? 'landing.promotional.button.trial.mobile'
                      : 'landing.promotional.button.trial'
                  }
                  defaultMessage="Start your free {trialDays}-day trial!"
                  values={{
                    trialDays,
                  }}
                />
              ) : (
                <FormattedMessage
                  id="plan.pro.without.trial"
                  defaultMessage="Create your account"
                />
              )}
            </CustomButtonPrimary>
          </ButtonContainer>
        </Section>
      )}
    </Media>
  );
};

export default Features;
